// global
import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Segment } from 'semantic-ui-react';
// local
import DefaultButton from 'app/components/commons/button/defaultButton/DefaultButton';
// styles
import styles from './DialogBox.module.scss';
// consts
import { COLORS } from 'app/config/colors';

function DialogBox(props) {
  const { options, children } = props;

  const {
    isOpen,
    title,
    description,
    confirmationTerm,
    cancelTerm = 'CANCELAR',
    onClose,
    onSubmit,
    size = 'tiny',
    showCancelButton = true,
    showConfirmButton = true,
    isDesativeButton = false,
    loading,
    image
  } = options;

  let confirmTermColor = {
    backgroundColor: COLORS.ACCENTUATED_VARIANT,
    borderColor: COLORS.ACCENTUATED_VARIANT,
    color: COLORS.WHITE_VARIANT,
    colorHover: COLORS.WHITE_VARIANT,
    backgroundColorHover: COLORS.ACCENTUATED_VARIANT_DARK,
    borderColorHover: COLORS.ACCENTUATED_VARIANT
  };

  if (isDesativeButton) {
    confirmTermColor = {
      backgroundColor: COLORS.ALERT_NEGATIVE,
      borderColor: COLORS.ALERT_NEGATIVE,
      color: COLORS.WHITE_VARIANT,
      colorHover: COLORS.WHITE_VARIANT,
      backgroundColorHover: COLORS.ALERT_NEGATIVE_DARK,
      borderColorHover: COLORS.ALERT_NEGATIVE_DARK
    };
  }

  return (
    <Modal size={size} open={isOpen} className={styles.modal}>
      <Modal.Header className={styles.header}>{title}</Modal.Header>
      <Segment vertical loading={loading} className={styles.segment}>
        <Modal.Content className={styles.content}>
          {image ? (
            <div className={styles.imageContainer}>
              <img src={image} alt='' />
            </div>
          ) : null}
          <p>{description}</p>
          {children}
        </Modal.Content>

        <Modal.Actions className={styles.actions}>
          {showCancelButton && (
            <DefaultButton
              tag={cancelTerm}
              onClick={onClose}
              backgroundColor={COLORS.WHITE_VARIANT}
              backgroundColorHover={COLORS.SECONDARY_VARIANT}
              borderColor={COLORS.SECONDARY_VARIANT}
              color={COLORS.PRIMARY_VARIANT}
              colorHover={COLORS.PRIMARY_VARIANT}
              borderColorHover={COLORS.SECONDARY_VARIANT}
            />
          )}
          {showConfirmButton && (
            <DefaultButton
              tag={confirmationTerm}
              onClick={onSubmit}
              backgroundColor={confirmTermColor.backgroundColor}
              borderColor={confirmTermColor.borderColor}
              color={confirmTermColor.color}
              colorHover={confirmTermColor.colorHover}
              backgroundColorHover={confirmTermColor.backgroundColorHover}
              borderColorHover={confirmTermColor.borderColorHover}
            />
          )}
        </Modal.Actions>
      </Segment>
    </Modal>
  );
}

DialogBox.defaultProps = {
  options: {
    showCancelButton: true,
    showConfirmButton: true,
    confirmationTerm: 'CONFIRMAR',
    cancelTerm: 'CANCELAR'
  }
};

DialogBox.propTypes = {
  options: PropTypes.object,
  isOpen: PropTypes.bool,
  size: PropTypes.string,
  title: PropTypes.string,
  image: PropTypes.string,
  description: PropTypes.oneOf([PropTypes.string, PropTypes.node]),
  confirmationTerm: PropTypes.string,
  cancelTerm: PropTypes.string,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  children: PropTypes.node
};

export default DialogBox;
